var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10a10 10 0 10-10 10h.104A9.907 9.907 0 0020 10.104V10zm-1.667 0a8.218 8.218 0 01-.299 2.194.417.417 0 01-.567.272 2.903 2.903 0 01-1.265-1.057l-1.848-2.773a2.083 2.083 0 00-1.733-.928h-.361a2.292 2.292 0 110-4.583h2.31a.417.417 0 01.24.077A8.328 8.328 0 0118.334 10zM1.816 8.462a.417.417 0 01.409-.333h3.614a2.897 2.897 0 012.063.854l.931.934a2.917 2.917 0 01.117 4L7.817 15.19a2.083 2.083 0 00-.525 1.385v.689a.417.417 0 01-.584.382A8.333 8.333 0 011.667 10a8.138 8.138 0 01.149-1.537z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a8967c08.svg";
export { ForwardRef as ReactComponent };